import { Spin } from 'antd'

function ANTDSpin({ ...props }) {
  return <Spin {...props} />
}

export default ANTDSpin
